import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {SalesDocumentVariant} from 'nutshell-graphql-types';
import type {
    GetEmailableQuotesByLeadIds as GetEmailableQuotesByLeadIdsQuery,
    GetEmailableQuotesByLeadIdsVariables as GetEmailableQuotesByLeadIdsVariables,
    GetEmailableQuotesByLeadIds_quotesForSend as SalesDocument,
} from 'nutshell-graphql-types';

import GET_EMABLEABLE_QUOTES_BY_LEAD_IDS from '../queries/get-emailable-quotes-by-lead-ids.graphql';

export const useGetEmailableSalesDocumentsByLeadIds = (
    leadIds: string[],
    documentType?: SalesDocumentVariant | null
): {
    salesDocuments: SalesDocument[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetEmailableQuotesByLeadIdsQuery,
        GetEmailableQuotesByLeadIdsVariables
    >(GET_EMABLEABLE_QUOTES_BY_LEAD_IDS, {
        variables: {
            leadIds,
            documentType,
        },
        fetchPolicy: 'cache-and-network',
        skip: leadIds.length === 0,
    });

    const quotesForSend = data ? data.quotesForSend : null;

    return {
        salesDocuments: quotesForSend || [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
